import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "empty" }
const _hoisted_2 = ["src"]

import { resolveWithBase } from '@/utils/pathUtils';

export default /*@__PURE__*/_defineComponent({
  __name: 'Empty',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(resolveWithBase)('icons/empty.svg'),
      class: "accent-svg"
    }, null, 8, _hoisted_2),
    _createElementVNode("h3", null, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})